import { EventEmitter, Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { MessageCenterService } from './message-center.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: "root",
})
export class ChatEmitterService {

  constructor(
    private notificationService: NotificationService,
    private messageCenterService: MessageCenterService
  ) { }
  public invokeChat = new EventEmitter();
  public subscriptionObject: Subscription;

  public newMessage = new EventEmitter();
  public newMessageSubscription: Subscription;

  public notificationCount = new EventEmitter();
  public notificationListSubscription: Subscription;

  public inboxCount = new EventEmitter();
  public inboxListSubscription: Subscription;

  openUserChatWindow(id) {
    this.invokeChat.emit(id);
  }

  newIncomingMessage(data) {
    this.newMessage.emit(data);
  }

  updateNotificationCount() {
    this.notificationService.updateNotificationCount();
    this.notificationCount.emit();
  }

  updateInboxCount() {
    this.messageCenterService.updateInboxCount();
    this.inboxCount.emit();
  }
}
